 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		41: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		41: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"10":"app-components-Workflow-WorkflowContainer","11":"app-components-bibs-BibPage-BibPageContainer","12":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","13":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","14":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","15":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","16":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","17":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","18":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","19":"app-components-bibs-subpages-CommentPage-CommentPageContainer","20":"app-components-bibs-subpages-MarcPage-MarcPageContainer","21":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","22":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","23":"app-components-bibs-subpages-VideoPage-VideoPageContainer","24":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","25":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","26":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","27":"app-components-borrowing-fines-Fines-FinesContainer","28":"app-components-borrowing-holds-Holds-HoldsContainer","29":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","30":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","31":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","32":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","33":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","34":"app-components-events-EventsSearchPage-EventsSearchPageContainer","35":"app-components-search-Search-SearchContainer","36":"app-components-search-SearchPrintList-SearchPrintListContainer","37":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","38":"app-components-shelves-Shelf-ShelfContainer","39":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","40":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"f1264deea529ef5c7075","1":"8bf2038f946c7180205e","2":"2e6f0e69c474b60e2f67","3":"94585398f9aed7abcf48","4":"d6da110e66f8b7cf6c76","5":"12b7b3323dd59d67153b","6":"178fc4d968f2fa2ce6ed","7":"f07441c272cb37fb15b3","8":"e9d5da6cae4a26874d81","9":"5284ea3e5eb39cb19df4","10":"b7dae2420939269992f7","11":"48283398b5ea1ccc17ef","12":"8db7af224359f07f828d","13":"c008c4b7f131ad04b257","14":"286541762c7b4352fd4f","15":"0e3fc3473a444e23fa97","16":"0043a7c945ca9562e633","17":"0f003a7ad8136a12ca9c","18":"cd9a177ab9a9fb708cfd","19":"ae2c14c49183a74fe500","20":"536ced79cba9eab0a03b","21":"57f7f0d4e2e1ca7828e3","22":"ae10b6667980273d2d96","23":"fd87c1fc51e743ae4559","24":"fb85bbc2e07235dd5e78","25":"2d1a8cf9720cc257a829","26":"2e04d804efff8f9cbe18","27":"c7813daf104dd6345475","28":"572f266db33d7bebc052","29":"d4177686b035c4b2c575","30":"64e37a3a85e279354d3b","31":"97d2a5cb5d649f73459f","32":"5ec12d795be42d0780d9","33":"af5bf2c86247271b08d9","34":"f5b9fd9ba636e10e00da","35":"ed2df309280abb417517","36":"8f1db19b3673fc5a539f","37":"94edbf2d43620804f472","38":"2c51515b89e349e13cf7","39":"5fe2bbf061194410c85a","40":"922570b742ffe7b3b702","42":"424eb7c9c3a91376060d","43":"eae775b605c95f210eb8","44":"79d14e96747d0a5addd9","45":"268976b2283ba5279a4b","46":"06d1233bf54516cc552c","47":"9bcc704dd7667342f480","48":"e2bec24d8f63c9f3556e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"10":"app-components-Workflow-WorkflowContainer","11":"app-components-bibs-BibPage-BibPageContainer","12":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","13":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","14":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","15":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","16":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","17":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","18":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","19":"app-components-bibs-subpages-CommentPage-CommentPageContainer","20":"app-components-bibs-subpages-MarcPage-MarcPageContainer","21":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","22":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","23":"app-components-bibs-subpages-VideoPage-VideoPageContainer","24":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","25":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","26":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","27":"app-components-borrowing-fines-Fines-FinesContainer","28":"app-components-borrowing-holds-Holds-HoldsContainer","29":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","30":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","31":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","32":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","33":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","34":"app-components-events-EventsSearchPage-EventsSearchPageContainer","35":"app-components-search-Search-SearchContainer","36":"app-components-search-SearchPrintList-SearchPrintListContainer","37":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","38":"app-components-shelves-Shelf-ShelfContainer","39":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","40":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"f1264deea529ef5c7075","1":"8bf2038f946c7180205e","2":"2e6f0e69c474b60e2f67","3":"94585398f9aed7abcf48","4":"d6da110e66f8b7cf6c76","5":"12b7b3323dd59d67153b","6":"178fc4d968f2fa2ce6ed","7":"f07441c272cb37fb15b3","8":"e9d5da6cae4a26874d81","9":"5284ea3e5eb39cb19df4","10":"b7dae2420939269992f7","11":"48283398b5ea1ccc17ef","12":"8db7af224359f07f828d","13":"c008c4b7f131ad04b257","14":"286541762c7b4352fd4f","15":"0e3fc3473a444e23fa97","16":"0043a7c945ca9562e633","17":"0f003a7ad8136a12ca9c","18":"cd9a177ab9a9fb708cfd","19":"ae2c14c49183a74fe500","20":"536ced79cba9eab0a03b","21":"57f7f0d4e2e1ca7828e3","22":"ae10b6667980273d2d96","23":"fd87c1fc51e743ae4559","24":"fb85bbc2e07235dd5e78","25":"2d1a8cf9720cc257a829","26":"2e04d804efff8f9cbe18","27":"c7813daf104dd6345475","28":"572f266db33d7bebc052","29":"d4177686b035c4b2c575","30":"64e37a3a85e279354d3b","31":"97d2a5cb5d649f73459f","32":"5ec12d795be42d0780d9","33":"af5bf2c86247271b08d9","34":"f5b9fd9ba636e10e00da","35":"ed2df309280abb417517","36":"8f1db19b3673fc5a539f","37":"94edbf2d43620804f472","38":"2c51515b89e349e13cf7","39":"5fe2bbf061194410c85a","40":"922570b742ffe7b3b702","42":"424eb7c9c3a91376060d","43":"eae775b605c95f210eb8","44":"79d14e96747d0a5addd9","45":"268976b2283ba5279a4b","46":"06d1233bf54516cc552c","47":"9bcc704dd7667342f480","48":"e2bec24d8f63c9f3556e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2249);
